import React from 'react';
import {HiOutlineSearch} from "react-icons/hi";
import {Nav, Navbar} from "react-bootstrap";
import {FaFilter} from "react-icons/fa";
import {AiFillWarning} from "react-icons/ai";
import Filter from '../../../../components/doctor/Filter';
import {withTranslation} from "react-i18next";
/*
import {filterPatientsTable} from "../../../../redux/actions/Tabs-Actions";
*/

import {compose} from "redux";
import {connect} from "react-redux";
import SvGraphics from "../../../../assets/SvGraphics";
import {filterPatientsTable} from "../../../../redux/actions/Tabs-Actions";
import {authenticationService} from "../../../../services/AuthenticationService";


class AllPatientsComposed extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuOpen: false,
            isSideBarOpen: false,
            searchValue: '',
            filters: {
                Status: [],
                Diagnosis: [],
                Treatment: [],
                Gender: [],
                Age: [0, 100],
            },
        }
    }

    applyFilter(name, cat, field) {
        let {filters} = this.state
        let catArr = filters[cat]
        let fieldName = field;
        if (!catArr.includes(fieldName)) {
            catArr.push(fieldName);
        } else {
            catArr.splice(fieldName)
        }
        filters[cat] = catArr
        this.props.filterPatientsTable('filters', filters);
        this.setState({filters});

    }



    openSideBar() {
        document.body.style.overflow = "hidden"
        this.setState({isSideBarOpen: true})
    }

    openMenu() {
        this.setState({menuOpen: true})
    }

    closeMenu() {
        this.setState({menuOpen: false})
    }

    searchPatientsTable(val) {
        this.setState({searchValue: val})
        this.props.searchPatientsTable(val)
    }

    render() {
        let {isSideBarOpen} = this.state
        let {t} = this.props
        let currentUser = authenticationService.currentUserValue;
        let leumitUser = currentUser?.profile?.Leumit_clinic

        return (
            <div>
                <div className={'allPatientBox'}>
                    {leumitUser === "T" && <div className={'adminFonts2'}> {t('doctor.all_patients_leumit')}</div>}
                    {leumitUser !== "T" && <div className={'adminFonts2'}> {t('doctor.all_patients')}</div>}
                    <div className={'all-patients-search-wrapper'}>
                        <div className={'sade-left-navbar-search-input-patient'}>
                            <input className={"navbar-search-input-patient"} placeholder={t('doctor.search_patient')}
                                   type="text" name="search"
                                   onChange={event => this.searchPatientsTable(event.target.value)} id={"search"}
                                   value={this.state.searchValue}/>
                            <SvGraphics className={"input-pic-patient"} svgname={'search'}/>
                        </div>
                        <div className={"patient-warning-icon"}>
                            <SvGraphics className={"patient-warning-icon-svg"} svgname={'warning-blue'}/>
                        </div>
                        <div className={"patient-filter-icon"}>
                            <SvGraphics className={"patient-warning-icon-svg"} svgname={'filter'}
                                        onClick={this.openSideBar.bind(this)}/>
                        </div>


                    </div>
                </div>
                {isSideBarOpen && <Filter
                    title={'Open filter'}

                    filterPatientsTable={(val) => this.filterPatientsTable(val)}
                    applyFilter={(name, cat, field) => this.applyFilter(name, cat, field)}
                    isSideBarOpen={isSideBarOpen}
                    filters={this.state.filters}
                    closeSideBar={() => this.setState({isSideBarOpen: false})}/>}
            </div>
        )
    }
}//
function mapDispatchToProps(dispatch) {
    return {
        filterPatientsTable: (type, payload) => dispatch(filterPatientsTable(type, payload))
    };
}

const mapStateToProps = state => {
    return {
        filterPatientsTable: state.patientsTableDataReducer.filterPatientsTable,
    };
};
const AllPatients = compose(
    withTranslation(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(AllPatientsComposed);

export default AllPatients;
